var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _vm.isMobilierRoute === false
      ? _c("div", { staticClass: "container-defaultForm" }, [
          _c("div", {
            staticClass: "containerLoader",
            class: { active: _vm.isLoaderActive }
          }),
          _c(
            "div",
            { staticClass: "containerForm" },
            [
              _vm.form
                ? _c("ma-form", {
                    attrs: { type: "large", formData: _vm.form },
                    on: {
                      change: function($event) {
                        return _vm.handleFormChange($event)
                      }
                    },
                    nativeOn: {
                      focus: function($event) {
                        return _vm.handleInputFocus()
                      }
                    }
                  })
                : _vm._e(),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.addDamageBtnIsHidden,
                      expression: "!addDamageBtnIsHidden"
                    }
                  ],
                  staticClass: "btn mainBlue mg mg--t-4",
                  attrs: {
                    "qa-add-damage-btn": "",
                    disabled: _vm.disableAddDamageButton
                  },
                  on: { click: _vm.handleAddDamage }
                },
                [_vm._v(_vm._s(_vm.$t("actions.addDamage")))]
              )
            ],
            1
          )
        ])
      : _c(
          "div",
          { staticClass: "container-mobilierForm" },
          [_c("ma-search-mobilier")],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }